export const getForgeLogoutUrl = (backlink?: string) => {
    return `https://accounts.autodesk.com/Authentication/LogOut?returntourl=${
        backlink ?? window.location
    }`;
};
